export const convertLengthKMetersToMiles = (kMeters) => kMeters * 0.621371;
export const convertLengthMetersToMiles = (meters) => meters * 0.621371 / 1000;
export const convertLengthMilesToKMeters = (miles) => miles / 0.621371;
export const convertLengthMilesToMeters = (miles) => miles / 0.621371 * 1000;
const feetToMeterRatio = 0.3048;
export const convertLengthFeetToMeters = (feet) => feet * feetToMeterRatio;
export const convertLengthMetersToFeet = (meters) => meters / feetToMeterRatio;
